<template>
  <div>
    <b-container class="row">
      <b-col>
        <dl class="row">
          <dt class="col-sm-3">Start Date</dt>
          <dd class="col-sm-9">{{ translationalTeam.startDate | formatDate }}</dd>
          <dt class="col-sm-3">End Date</dt>
          <dd class="col-sm-9">{{ translationalTeam.endDate | formatDate }}</dd>
        </dl>
      </b-col>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    translationalTeam: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
  font-size: 12px;
}
</style>
